import { AppState } from '../../index';
import { STATE_KEY } from './constants';
import { AuthState } from './model';

const selectAuth = (state: AppState): AuthState => state[STATE_KEY];
export const selectAuthRequestInFlight = (state: AppState): boolean => selectAuth(state).status.inFlight;
export const selectAuthRequestSuccess = (state: AppState): boolean => selectAuth(state).status.success;
export const selectIsAuthenticated = (state: AppState): boolean => selectAuth(state).authData.isAuthenticated;
